/**
 * Runtime configuration loader.
 *
 * Fetches /config.json (served by nginx from a ConfigMap mount) containing
 * Keycloak URL and the API base URL. The Keycloak realm is derived from the
 * hostname subdomain (e.g. cpty-1.truweb.io -> realm "cpty-1"). This works
 * identically in local dev (cpty-1.localhost) and production.
 */

let _config = null;

export async function loadConfig() {
    if (_config) return _config;

    const resp = await fetch("/config.json");
    if (!resp.ok) {
        throw new Error(`Failed to load /config.json: HTTP ${resp.status}`);
    }
    _config = await resp.json();
    return _config;
}

export function getConfig() {
    if (!_config) {
        throw new Error("Config not loaded yet - call loadConfig() first");
    }
    return _config;
}

/**
 * Derive the Keycloak realm from the hostname subdomain.
 *
 * Examples:
 *   cpty-1.truweb.io       -> "cpty-1"
 *   cpty-1.dev.truweb.io   -> "cpty-1"
 *   cpty-1.localhost        -> "cpty-1"
 *   cpty-1.localhost:8080   -> "cpty-1"
 *   localhost               -> fallback from config.json
 *
 * The first segment of the hostname (before the first dot) is the cpty code,
 * which is also the Keycloak realm name. This is the same mechanism used in
 * production with wildcard DNS (*.truweb.io).
 */
/**
 * Whether the current hostname is a platform portal (`admin.*` or
 * `supervisor.*`). Both are `ksl-admin`-realm users with no cpty-scoped data and
 * both sign in through Keycloak's hosted flow (the only flow that supports a
 * YubiKey); the role differentiates capability. Every other subdomain is a cpty
 * portal with the custom sign-in form.
 */
export function isPlatformPortal() {
    const subdomain = window.location.hostname.split(".")[0].toLowerCase();
    return subdomain === "admin" || subdomain === "supervisor";
}

